module.exports = __webpack_public_path__ + "img/a0.02a8d051.png";